import { SET_IS_NEW_RECORD } from '../actionTypes';
import { companyRolesActions } from '../reducer';

export default (value) => companyRolesActions[SET_IS_NEW_RECORD](value);
